import { NavigationConfig } from "../shared/core/models/navigation-config.interface";
import { NavigationMenuEntry } from "../shared/core/models/navigation-menu-entry.interface";

const menuItems: NavigationMenuEntry[] = [
    {
        name: 'Home',
        isExternal: false,
        route: '/'
    },
    {
        name: 'About Us',
        isExternal: false,
        route: '/about'
    },
    {
        name: 'The Vest',
        isExternal: false,
        route: '/the-vest'
    },
    {
        name: 'Shop Now',
        isExternal: false,
        route: '/store'
    },
    {
        name: 'Coaching',
        isExternal: false,
        route: '/coaching'
    },
    {
        name: 'Download Our App',
        isExternal: false,
        route: '/download-our-app'
    },
    {
        name: 'Blog',
        isExternal: false,
        route: '/blog'
    }
];

export const navConfig: NavigationConfig = {
    menuItems: menuItems
};